import { Grid, Typography } from "@mui/material"
import styles from './SuccessfulReferralCardContent.module.css'
import Spacer from "../../atoms/Spacer/Spacer"
import { UserInfo } from "../../../types"
import { useTranslation } from "react-i18next"

interface SuccessfulReferralCardContentProps {
    referredUsers?: UserInfo[]
}

const SuccessfulReferralCardContent = (props: SuccessfulReferralCardContentProps) => {
    const referralBonusAmount = 10
    const { t } = useTranslation()
    return <Grid container spacing={1} direction="row">
        <Grid item xs={3} className={styles.referralNumberGrid}>
            <Typography className={styles.referralNumberGrid}>{props.referredUsers?.length}</Typography>
        </Grid>
        <Grid item xs={9} direction="column">
            <Typography className={styles.successfulReferralsTitle}>{t(`profile_referral_page_successful_referrals_title`)}</Typography>
            <Spacer height={10} />
            <Typography variant='h4' className={styles.amountEarnedText}>{t(`profile_referral_page_amount_earned`, { amount: (props.referredUsers?.length ?? 0) * referralBonusAmount })}</Typography>
            <Typography fontWeight='400'>{t(`profile_referral_page_cta_text`)}</Typography>
        </Grid>
    </Grid>

}

export default SuccessfulReferralCardContent
